// @ts-nocheck
import { swatchItemSpacing } from "@store/Themes/common/props/swatch";
import { css } from "styled-components";

export const swatchListStyles = () => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${swatchItemSpacing};
`;

export const swatchListItemStyles = () => css`
    display: flex;
    max-width: 100%;
`;
